export const createHashId = (item) => {
  const { nome, documento, tipo } = item;
  const dataString = `${nome}_${documento || 'null'}_${tipo}`;
  
  let hash = 0;
  for (let i = 0; i < dataString.length; i++) {
    const char = dataString.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Converte para 32-bit integer
  }
  return Math.abs(hash).toString();
};
